<template>
    <span v-if="isCombo" style="text-align: right">
      <span>
        {{ finalPrice | currency }}
      </span>
  </span>
  <span v-else-if="shouldDisplayStrikedOutPrice" style="text-align: right">
    <span style="text-decoration: line-through;" :class="{'breakDiscount': breakDiscountResult}">
      {{ originalPrice | currency }}
    </span>

    <span class="ml-1 red--text" :class="{'breakDiscount': breakDiscountResult}">
      <span v-if="showSign && !!finalPrice">
        +
      </span>

      {{ finalPrice | currency }}
    </span>
  </span>
  <span v-else-if="finalPrice > 0 || showZero">
    <span v-if="showParans">
      (<span v-if="showSign && !!finalPrice">
        +
      </span>{{ finalPrice | currency }})
    </span>
    <span v-else>
      <span v-if="showSign && !!finalPrice">
        +
      </span>

      {{ finalPrice | currency }}
    </span>
  </span>
</template>
<script>
  import { mapGetters } from 'vuex'
  import get from 'lodash/get';


  export default {
    props: {
      isCombo: {
        type: Boolean,
        default: false
      },
      initCharges: {
        type: Array,
        default: () => ([])
      },
      initQuantity: {
        type: Number,
        default: 1
      },
      onlyFinalValue: {
        type: Boolean,
        default: false
      },
      showSign: {
        type: Boolean,
        default: false
      },
      showParans: {
        type: Boolean,
        default: false
      },
      showZero: {
        type: Boolean,
        default: false
      },
      breakDiscount: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      breakDiscountResult() {
        if (this.shouldDisplayStrikedOutPrice)
          // Break discount if the prpo is true (usually on small breakpoints) or if the length exceeds the expected length
          return this.breakDiscount || (''+this.originalPrice+''+this.finalPrice).length >= 8
        return false
      },

      shouldDisplayStrikedOutPrice() {
        const charge = this.getFinalCharge || {}
        if(!charge.promotional) {
          return false
        }
        return !this.onlyFinalValue && this.finalPrice != null && this.originalPrice > this.finalPrice
      },

      originalPrice() {
        return get(this.getOriginalCharge, 'price', '') * this.initQuantity
      },
      getOriginalCharge() {
        return this.getOriginalChargeFromCharges(this.initCharges)
      },

      finalPrice() {
        return get(this.getFinalCharge, 'price', '') * this.initQuantity
      },
      getFinalCharge() {
        const currentItem = this.getWorkingMenuItem
        if (currentItem && currentItem.relations && currentItem.relations.length > 0) {
          return this.getFinalChargeFromCharges(this.initCharges, true)
        } else {
          return this.getFinalChargeFromCharges(this.initCharges)
        }
      },

      ...mapGetters([
        'getFinalChargeFromCharges',
        'getOriginalChargeFromCharges',
        'getWorkingMenuItem',
        'getMenuItemDialog'
      ])
    },
    created(){
      if (this.getMenuItemDialog && this.getWorkingMenuItem.relations && this.getWorkingMenuItem.relations.length) {
        this.isCombo = true
      }
    }
  }
</script>

<style media="screen">
  .breakDiscount {
    display: inline-block;
  }
</style>
